import { USER_MOBILE } from './types'

const INITIAL_STATE = {
  mobile: '',
}

const mobileReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case USER_MOBILE: {
      return {
        ...state,
        mobile: action.payload,
      }
    }
    default:
      return state
  }
}

export default mobileReducer
